module.exports = __webpack_public_path__ + "static/media/man.d7e91526.png";